import { ChangeDetectorRef, Injectable } from '@angular/core';
import { act, Actions, createEffect, ofType } from '@ngrx/effects';
import {
  map,
  catchError,
  tap,
  mergeMap,
  withLatestFrom,
  exhaustMap,
} from 'rxjs/operators';
import { of } from 'rxjs';
import * as fromAdminActions from '../actions/admin.action';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { NavigationExtras, Router } from '@angular/router';
import { setLoadingSpinner } from '../actions/shared.action';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';
import { getUserProfile } from '../actions/account.action';
import { AdminService } from 'src/app/services/admin.service';

@Injectable()
export class AdminEffects {

  createEmployee$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAdminActions.createEmployee),
      exhaustMap((action) => 
        this.adminService.createEmployee(action?.data).pipe(
          map((response)=>{
            return fromAdminActions.createEmployeeSuccess({data: response?.details})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAdminActions.createEmployeeFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  createEmployeeSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAdminActions.createEmployeeSuccess),
        tap(async (action) =>{
          this.store.dispatch(setLoadingSpinner({status: false}));
          this.modalService.hideCreateEmployee();
          const message = {
            message: 'Employee created.' 
          }
          this.modalService.successModal(message)
        })
      ),
    { dispatch: false }
  );

  createEmployeeFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromAdminActions.createEmployeeFailed),
        tap(async (action) =>{
          this.store.dispatch(setLoadingSpinner({status: false}))
          
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private adminService: AdminService,
    private router: Router,
    private modalService: ModalService
  ) {}
}
